import Profil from "./components/Common/Pages/Profil";
import APIKey from "./components/Admin/APIKEY/APIKey";
import UserManagement from "./components/UserManagement/UserManagement";
import DashboardRepport from "./components/Reports/DashboardReports/DashboardReport";
import WriteReportView from "./components/Reports/EditReports/WriteReportView";
import ComplainForm from "./components/Casserole/Plaintes/ComplainForm";
import AccessRightManagement from "./components/Admin/AccessRight/AccessRightManagement";
import ArticleView from "./components/Articles/DisplayArticles/ArticleView";
import WriteArticleView from "./components/Articles/EditArticles/WriteArticleView";
import SpecialMessageEditor from "./components/Casserole/SpecialMessage/SpecialMessageEditor";
import FranchiseeSurvey from "./components/Survey/FranchiseeSurvey";
import InternalEmployeeSurvey from "./components/Survey/InternalEmployeeSurvey";
import RecipesView from "./components/Recipes/RecipesView";
import BottinTelephonique from "./components/BotinTelephonique/BottinTelephonique";
import ComplaintAdmin from "./components/Casserole/Plaintes/Admin/ComplaintAdmin";
import CompanyView from "./components/CompaniesManagement/CompanyView";
import LocationView from "./components/Emplacement/LocationView";
import InternalUserManagementView from "./components/Admin/InternalUserManagement/InternalUserManagementView";
import DashboardView from "./components/Dashboard/Franchises/DashboardView";
import VideoView from "./components/VideoSection/VideoView";
/*import ArticleEditorPage from "./components/Articles/ArticleEditor/ArticleEditorPage";*/

const AppRoutes = [
  {
    index: true,
    element: <ArticleView />,
    requiredRole: null,
  },
  {
    path: "/Articles",
    element: <ArticleView />,
    requiredRole: null,
  },
  {
    path: "/WriteArticle",
    element: <WriteArticleView />,
    requiredRole: ["AdminTI", "ArticleWriter", "ArticleAdmin"],
  },
  // Nouvelle route pour le nouvel éditeur complet
  /*{
    path: "/new-article-editor",
    element: <ArticleEditorPage />,
    requiredRole: ["AdminTI", "ArticleWriter", "ArticleAdmin"], // rôles requis si besoin
  },
  */
  {
    path: "/Profil",
    element: <Profil />,
    requiredRole: null,
  },
  {
    path: "/SpecialMessage",
    element: <SpecialMessageEditor />,
    requiredRole: ["AdminTI", "CasseroleAdmin"],
  },
  {
    path: "/APIKey",
    element: <APIKey />,
    requiredRole: ["AdminTI"],
  },
  {
    path: "/UserManagement",
    element: <UserManagement />,
    requiredRole: ["AdminTI", "Franchisees", "Manager", "InternalEmployee"],
  },
  {
    path: "/InternalUserManagement",
    element: <InternalUserManagementView />,
    requiredRole: ["AdminTI", "InternalUsermanagers"],
  },
  {
    path: "/CompanyManagement",
    element: <CompanyView />,
    requiredRole: ["AdminTI", "CompanyAdmin", "CompanyReader"],
  },
  {
    path: "/Location",
    element: <LocationView />,
    requiredRole: ["AdminTI", "LocationAdmin", "LocationReader"],
  },
  {
    path: "/Reports",
    element: <WriteReportView />,
    requiredRole: ["AdminTI", "ReportAdmin", "ReportWriter"],
  },
  {
    path: "/DashboardReport",
    element: <DashboardRepport />,
    requiredRole: ["AdminTI", "ReportAdmin", "ReportWriter"],
  },
  {
    path: "/CompetitionSurveyFranchisees",
    element: <FranchiseeSurvey />,
    requiredRole: ["AdminTI", "Franchisees"],
  },
  {
    path: "/CompetitionSurveyInternalEmployees",
    element: <InternalEmployeeSurvey />,
    requiredRole: ["AdminTI", "InternalEmployee"],
  },
  {
    path: "/Complaint",
    element: <ComplainForm />,
    requiredRole: null,
  },
  {
    path: "/ComplaintAdmin",
    element: <ComplaintAdmin />,
    requiredRole: ["AdminTI", "CasseroleAdmin"],
  },
  {
    path: "/AccessRight",
    element: <AccessRightManagement />,
    requiredRole: ["AdminTI"],
  },
  {
    path: "/Recipes",
    element: <RecipesView />,
    requiredRole: null,
  },
  {
    path: "/Videos",
    element: <VideoView />,
    requiredRole: ["AdminTI"],
  },
  {
    path: "/Bottin",
    element: <BottinTelephonique />,
    requiredRole: null,
  },
  {
    path: "/Dashboard",
    element: <DashboardView />,
    requiredRole: ["AdminTI"],
  },
];

export default AppRoutes;
